import { z } from 'zod';

export const DEPARTMENTS = ['deck', 'engine', 'catering'] as const;
export type Department = (typeof DEPARTMENTS)[number];
export const departmentSchema = z.enum(DEPARTMENTS);

/** Position code format used in the `positions` table and in photo paths (PLAN §2.2, §2.8). */
export const positionCodeSchema = z.string().regex(/^[A-Z0-9]{1,12}$/);
export type PositionCode = z.infer<typeof positionCodeSchema>;

export interface KnownPosition {
  code: PositionCode;
  department: Department;
}

/**
 * Positions known before the master Excel import. The server `positions` table is the source of
 * truth; Task 4 adds whatever else the master file contains (Q10).
 */
export const KNOWN_POSITIONS: readonly KnownPosition[] = [
  { code: 'MASTER', department: 'deck' },
  { code: 'CO', department: 'deck' },
  { code: '2O', department: 'deck' },
  { code: '3O', department: 'deck' },
  { code: 'CE', department: 'engine' },
  { code: '2E', department: 'engine' },
  { code: '3E', department: 'engine' },
  { code: 'ETO', department: 'engine' },
];

export const MASTER_POSITION: PositionCode = 'MASTER';
export const CHIEF_ENGINEER_POSITION: PositionCode = 'CE';
